// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@steiner/XDL/types";

export default {
    popover: 1260,
    datePicker: 1270,
    dynamicDropdown: 1200,
    stickyFooter: 1284,
    loadingOverlay: 1283,
    menu: 1280,
    drawer: 1290,
    modal: 1305,
    tabGroup: 400,
    toaster: 1600,
    shellPopover: 6000,
    // XNG-Changes
    tippy: 1500,
    floatingUi: 1500,
    tooltip: 1306,
    header: 1284,
    compactHeader: 1283,
    styledOverlay: 1281,
    dynamicDropdownInModal: 1310,
    compareFlyoutTooltip: 1311,
} as xBaseTheme["zIndex"];
